<template>
  <el-row style="height:100%;">
    <el-col v-loading="loading" :xs="24" :sm="12" :md="10" style="height:100%;">
      <div class="left-pane">
        <div class="flex">
          <img src="/images/nexus_flat_logo.png" style="margin-top: 6px; height: 64px;" />
          <h1
            v-if="$mq != 'xs'"
            class="logo"
            style="margin: 16px 16px 16px 0px; font-size: 40px;"
          >Nexus</h1>
        </div>
        <h5
          v-if="dev"
          style="margin-left: 16px; color:red;"
        >NOTICE: Development Environment Detected</h5>
        <div class="flex-box">
            <el-form ref="form" :model="form" :rules="rules" style="width: 100%; margin: 40px;">
              <h1
                v-if="$mq === 'xs'"
                class="logo"
                style="margin: 16px; text-align:center; font-size: 40px;"
              >Nexus</h1>
              <el-form-item prop="un">
                <el-input v-model="form.un" name="un" placeholder="Username">
                  <template slot="prepend">
                    <i
                      style="font-size: 18px; line-height: 2;"
                      class="material-icons"
                    >account_circle</i>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="form.password"
                  name="password"
                  type="password"
                  placeholder="Password"
                  auto-complete="off"
                  @keyup.enter.native="submitForm('form')"
                >
                  <template slot="prepend">
                    <i style="font-size: 18px; line-height: 2;" class="material-icons">lock</i>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                  <el-button
                    type="primary"
                    size="small"
                    style="margin: 8px"
                    @click="submitForm('form')"
                  >Login</el-button>
              </el-form-item>
            </el-form>
        </div>
      </div>
    </el-col>
    <el-col :sm="12" :md="14" style="height:100%;" class="hidden-xs">
      <vue-particles
        color="#ffffff"
        style="height: 100%"
        :particleOpacity="0.9"
        :particlesNumber="140"
        shapeType="circle"
        :particleSize="5"
        linesColor="#ffffff"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="160"
        :moveSpeed="3"
        :hoverEffect="false"
        :clickEffect="false"
      >
        <span style="width: 100%; height: 100%"></span>
      </vue-particles>
    </el-col>
  </el-row>
</template>

<script>
export default {
    components: {},
    props: ["oldUsername", "csrfField", "dev", "redirect"],
    data() {
        return {
            loading: false,
            form: {
                un: this.oldUsername,
                password: "",
                remember: false
            },
            rules: {
                un: [
                    {required: true, message: "Please enter username", trigger: "blur"}
                ],
                password: [
                    {
                        required: true,
                        message: "Please enter password",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    computed: {},
    methods: {
        submitForm(formName) {
            this.loading = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios
                        .post("/login", JSON.stringify(this.form), {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin",
                            maxRedirects: 0
                        })
                        .then(() => {
                            window.location= this.redirect ? this.redirect : '/';
                        })
                        .catch((err) => {
                            this.loading = false;
                            this.$message({
                                showClose: true,
                                message: err.response.data.errors.un[0],
                                type: "error"
                            });
                        });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
